
export class QRCodeExtension {
}
